export const ListQueryKey = 'activityZskConfigs';
export const DetailQueryKey = 'activityZskConfig';
export const Urls = {
  selectUrl: '/ZskAuth/list',
  updateUrl: '/ZskAuth/update',
  deleteUrl: '/ZskAuth/delete',
  createUrl: '/ZskAuth/create',
  detailUrl: '/ZskAuth/detail'
};